module.exports = __webpack_public_path__ + "media/Synchron_bestimmt_stark.85e84e60.mp3";